import type { ITooltipContent } from "@/types/library/Tooltips";
import Button from "@/components/library/Buttons/Button";
import { ButtonType } from "@/types/library/Buttons";

const TooltipContent: React.FC<ITooltipContent> = ({
  id = "",
  title,
  info,
  buttonText = "",
  buttonOnClick,
  showButton = false,
  width = "w-64",
}) => {
  return (
    <div
      id={id}
      data-testid={id}
      className="z-50 rounded-xl bg-dines-purple-darkest p-4 text-white"
    >
      {title && (
        <h1
          className="font-bold text-lg"
          id={`${id}-title`}
          data-testid={`${id}-title`}
        >
          {title}
        </h1>
      )}

      <p className={width} id={`${id}-info`} data-testid={`${id}-info`}>
        {info}
      </p>
      {showButton && (
        <Button
          id={`${id}-button`}
          text={buttonText}
          buttonType={ButtonType.Primary}
          onClick={buttonOnClick}
        />
      )}
    </div>
  );
};

export default TooltipContent;
